import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  line-height: 30px;
`

interface IPrerequisiteProps {
  istotal: string
}

export const Tag = styled.span<IPrerequisiteProps>`
  ${(props) =>
    props.istotal === 'true'
      ? css`
          font-weight: 700;
          color: #4c4c4c;
        `
      : css`
          color: #363636;
        `}
  float: left;
  height: 32px;
  max-width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 6px;
  border: 1px solid #bfbfbf;
  border-radius: 8px;
  font-size: 12px;
  margin-right: 8px;
`

export const TooltipItem = styled.div`
  margin-right: 2px;
  svg {
    font-size: 4px;
    margin-right: 8px;
    margin-left: 4px;
    margin-bottom: 2px;
  }
`

export const TooltipTitle = styled.span`
  font-size: 12px;
  font-family: 'Roboto';
`
